<template>
  <v-container class="planes-section py-8 py-md-12">
    <!-- Encabezado -->
    <v-row id="seccionPlanes" class="text-center mb-4 mb-md-8">
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <div class="section-badge mb-3">Planes</div>

        <h2 class="header-title mb-3">
          Elige el plan ideal para ti
        </h2>

        <p class="header-subtitle mb-0">
          Filtra según tus necesidades y encuentra la opción que mejor se adapta a ti y tu familia.
        </p>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-row justify="center" class="mb-4 mb-md-6">
      <v-col cols="12" md="11" lg="10">
        <v-card class="filters-card pa-3 pa-md-4" flat>
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="filtros.tipo"
                :items="tiposPlan"
                label="Tipo de plan"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-account-group-outline"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="filtros.edad"
                :items="edadesPlan"
                label="Edad"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-calendar-account"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="filtros.hospital"
                :items="hospitalesPlan"
                label="Red de atención"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-hospital-building"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Resultados -->
    <v-row justify="center" class="mb-2">
      <v-col cols="12" md="11" lg="10">
        <div class="results-text mb-3">
          {{ planesFiltrados.length }}
          {{ planesFiltrados.length === 1 ? 'plan encontrado' : 'planes encontrados' }}
        </div>
      </v-col>
    </v-row>

    <!-- Cards -->
    <v-row justify="center" dense>
      <v-col
        v-for="(plan, index) in planesFiltrados"
        :key="plan.id"
        cols="12"
        sm="6"
        lg="4"
        class="d-flex px-2 py-2"
        :style="{ animationDelay: `${index * 0.1}s` }"
      >
        <v-card class="plan-card d-flex flex-column flex-grow-1" flat>
          <div class="plan-card__top">
            <div class="plan-type mb-2">
              {{ plan.tipo }} · {{ plan.hospital }}
            </div>

            <h3 class="plan-title mb-2">
              {{ plan.title }}
            </h3>

            <div class="price-box mb-4">
              <div class="price-amount">
                {{ $formatCurrency(plan.costo) }}
              </div>
              <div class="price-label">
                Pago mensual
              </div>
            </div>
          </div>

          <v-card-text class="pt-0 flex-grow-1">
            <ul class="benefits-list">
              <li
                v-for="(item, i) in plan.beneficios"
                :key="`${plan.id}-beneficio-${i}`"
                class="benefit-item"
              >
                <v-icon color="success" small class="benefit-icon">
                  mdi-check-circle
                </v-icon>
                <span class="benefit-text" v-html="item"></span>
              </li>
            </ul>
          </v-card-text>

          <v-card-actions class="pt-0 pb-5 px-5">
            <v-btn
              block
              large
              color="success"
              class="whatsapp-btn font-weight-bold"
              @click="whatsappLink(plan.title)"
            >
              <v-icon left>mdi-whatsapp</v-icon>
              Cotizar por WhatsApp
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Sin resultados -->
      <v-col v-if="!planesFiltrados.length" cols="12" md="8" lg="6">
        <v-card class="empty-state pa-6 text-center" flat>
          <v-icon size="42" color="grey lighten-1" class="mb-3">
            mdi-magnify-close
          </v-icon>
          <h3 class="empty-title mb-2">No encontramos planes con esos filtros</h3>
          <p class="empty-text mb-4">
            Prueba cambiando el tipo de plan, la edad o la red de atención.
          </p>
          <v-btn outlined color="primary" @click="limpiarFiltros">
            Limpiar filtros
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SeccionPlanesComponent',

  data() {
    return {
      filtros: {
        tipo: 'Todos',
        edad: 'Todos',
        hospital: 'Todos'
      },

      tiposPlan: ['Todos', 'Individual', 'Familiar'],
      edadesPlan: ['Todos', 'General', 'Mayores de 50'],
      hospitalesPlan: ['Todos', 'Red General', 'La Bene'],

      planes: [
        {
          id: '1',
          title: 'Plus Familiar',
          costo: 1400,
          tipo: 'Familiar',
          edad: 'General',
          hospital: 'Red General',
          beneficios: [
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
            'Incluye a tus <b>familiares directos</b> como beneficiarios',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y los beneficiarios de tu familia',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        },
        {
          id: '2',
          title: 'La Bene Familiar',
          costo: 1200,
          tipo: 'Familiar',
          edad: 'General',
          hospital: 'La Bene',
          beneficios: [
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
            'Incluye a tus <b>familiares directos</b> como beneficiarios',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y los beneficiarios de tu familia',
            'Paquetes de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        },
        {
          id: '3',
          title: 'Plus Individual',
          costo: 650,
          tipo: 'Individual',
          edad: 'General',
          hospital: 'Red General',
          beneficios: [
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        },
        {
          id: '4',
          title: 'Plus Individual 50',
          costo: 1200,
          tipo: 'Individual',
          edad: 'Mayores de 50',
          hospital: 'Red General',
          beneficios: [
            'Diseñado especialmente para quienes tienen más de 50 años',
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        },
        {
          id: '5',
          title: 'La Bene Individual 50',
          costo: 1100,
          tipo: 'Individual',
          edad: 'Mayores de 50',
          hospital: 'La Bene',
          beneficios: [
            'Diseñado especialmente para quienes tienen más de 50 años',
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        }
      ]
    };
  },

  computed: {
    planesFiltrados() {
      return this.planes.filter(plan => {
        const { tipo, edad, hospital } = this.filtros;

        return (
          (tipo === 'Todos' || plan.tipo === tipo) &&
          (edad === 'Todos' || plan.edad === edad) &&
          (hospital === 'Todos' || plan.hospital === hospital)
        );
      });
    }
  },

  methods: {
    limpiarFiltros() {
      this.filtros = {
        tipo: 'Todos',
        edad: 'Todos',
        hospital: 'Todos'
      };
    },

    whatsappLink(plan) {
      const telefono = process.env.VUE_APP_BASE_PHONEWHATSWEB;
      const mensaje = `Hola, quisiera una cotización de ${plan}`;
      const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.planes-section {
  background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
  border-radius: 28px;
}

.section-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.header-title {
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  font-weight: 800;
  line-height: 1.2;
  color: #0f172a;
}

.header-subtitle {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
  max-width: 720px;
  margin: 0 auto;
}

.filters-card {
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid #e5edf8;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);
}

.results-text {
  font-size: 0.95rem;
  color: #64748b;
  font-weight: 600;
}

.plan-card {
  height: 100%;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #eaf0f7;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  opacity: 0;
  transform: translateY(24px);
  animation: fadeInUp 0.55s ease forwards;
  transition:
    transform 0.28s ease,
    box-shadow 0.28s ease,
    border-color 0.28s ease;
}

.plan-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 18px 38px rgba(37, 99, 235, 0.14);
  border-color: #cfe0ff;
}

.plan-card__top {
  padding: 24px 24px 8px;
  text-align: center;
}

.plan-type {
  font-size: 0.82rem;
  font-weight: 700;
  color: #2563eb;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.plan-title {
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.25;
  color: #0f172a;
}

.price-box {
  padding: 18px 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
  border: 1px solid #dbeafe;
}

.price-amount {
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  font-weight: 800;
  line-height: 1.1;
  color: #111827;
}

.price-label {
  margin-top: 6px;
  font-size: 0.9rem;
  color: #64748b;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
}

.benefit-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.benefit-text {
  flex: 1;
  display: block;
  color: #475569;
  font-size: 0.96rem;
  line-height: 1.6;
  word-break: break-word;
}

.whatsapp-btn {
  text-transform: none !important;
  border-radius: 14px;
  letter-spacing: 0.2px;
}

.empty-state {
  border-radius: 22px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
}

.empty-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
}

.empty-text {
  color: #64748b;
  line-height: 1.6;
}

@keyframes fadeInUp {
  from {
    transform: translateY(24px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 600px) {
  .planes-section {
    border-radius: 18px;
  }

  .plan-card__top {
    padding: 20px 20px 8px;
  }

  .price-box {
    padding: 16px 12px;
  }
}
</style>